/* TODO: t() */
import React, { Component } from 'react';
import { TextInput } from '../../../uiold';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';
import { validateRealTime } from './validators';

type Props = {
  definition: FormFieldDefinition;
  value: string;
  onChange: (id: string, value: string) => void;
};

class TextInputElementEditView extends Component<Props> {
  static defaultProps = {
    value: '',
  };

  render() {
    let { definition } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'TextElement') {
      return null;
    }

    let multi = definition.multiline
      ? {
          multiline: true,
          numberOfLines: 3,
        }
      : {};

    return (
      <TextInput
        testID={`form-text-input-${definition.id}`}
        {...multi}
        value={this.props.value}
        onChangeText={this._setValue}
        placeholder={definition.placeholder || ''}
      />
    );
  }

  _setValue = (value: string) => {
    let { definition, onChange } = this.props;
    if (definition.type === 'TextElement') {
      if (definition.field_validation) {
        value = validateRealTime(definition.field_validation, value);
      }
    }
    onChange(definition.id, value);
  };
}

export default TextInputElementEditView;
